import { isProdProject } from '../../utils/supabase/info';

/**
 * Тестовый ли это стенд.
 *
 * Раньше определялось по адресу в браузере, потому что образ у стендов был
 * один: `projectId` лежал константой в коде, и отличить сборки было нечем.
 * Теперь проект задаётся на сборке — и вопрос «тест или бой» сводится к
 * единственному, что его на самом деле решает: в какую базу мы ходим.
 *
 * Хост больше не при чём. Стенд, собранный против боевого проекта, тестовым
 * не является, как бы он ни назывался, — и витрину компонентов на нём
 * показывать незачем.
 */
export function isTestEnvironment(): boolean {
  if (import.meta.env.DEV) return true;
  return !isProdProject;
}
